export default {
  LOAD_USER_NAME (state, payload) {
    state.userFullName = payload
  },
  LOAD_USER_ROLE (state, payload) {
    state.userRole = payload
  },
  LOAD_USER_OBJECT (state, payload) {
    state.userObj = payload
  },
  LOAD_USERS (state, payload) {
    state.users = payload
  },
  LOAD_USER (state, payload) {
    state.user = payload
  },
  LOAD_USER_ADVISOR (state, payload) {
    state.advisor = payload
  },
  LOAD_PERMISSION (state, payload) {
    state.permission = payload
  },
  LOAD_USER_CAREER_GOAL (state, payload) {
    state.careerGoal = payload
  },
  LOAD_USER_PREFERENCES (state, payload) {
    state.userPreferences = payload
  },
  LOAD_ZENDESK_WIDGET_TOKEN (state, payload) {
    state.zendeskWidgetToken = payload
  },
  LOAD_ZENDESK_WIDGET_ID (state, payload) {
    state.zendeskWidgetId = payload
  },
  LOAD_ZENDESK_WIDGET_THEME (state, payload) {
    state.zendeskWidgetTheme = payload
  },
  LOAD_TEMP_USER_FLAG (state, payload) {
    state.tempUser = payload
  },
  LOAD_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  LOAD_FORCE_RESET_TOUR_ELEMENTS (state, payload) {
    state.forceResetTourElements = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/user/vuex/mutations.js